module.exports = __webpack_public_path__ + "img/icon_parkingService.24b0c2ec.png";